/**
 *
 * ResourceName
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ClassNames from 'classnames';
import _inRange from 'lodash/inRange';
import { isIE } from 'utils/stringUtils';

const useStyles = makeStyles(theme => ({
  root: {
    ...theme.typography.h2,
    flex: 1,
    display: '-webkit-box',
    margin: '0 auto',
    '-webkit-line-clamp': '3',
    '-webkit-box-orient': 'vertical',
    overflow: props => (props.isIE ? 'visible' : 'hidden'),
    textOverflow: 'ellipsis',
    [theme.breakpoints.down('xs')]: {
      ...theme.typography.h5,
    },
  },
  smallerTitle: theme.typography.h4,
  smallestTitle: theme.typography.h5,
}));

function ResourceName(props) {
  const classes = useStyles({ isIE: isIE() });
  const { name, nameLen } = props;
  const titleLen = nameLen || (name && name.length);
  return (
    <Typography
      variant="h1"
      color="textPrimary"
      className={ClassNames(
        classes.root,
        _inRange(titleLen, 80, 100)
          ? classes.smallerTitle
          : _inRange(titleLen, 100, 200)
          ? classes.smallestTitle
          : undefined,
      )}
    >
      {name}
    </Typography>
  );
}

ResourceName.propTypes = {
  name: PropTypes.string,
  nameLen: PropTypes.string, // only for parsedData
};

export default ResourceName;
